export const FETCH_REFERRAL_CAMPAIGNS = 'FETCH_REFERRAL_CAMPAIGNS'

export const URL_HOME = '/referrals'